import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { GraduationCap, Award, ArrowRight } from "lucide-react";
import { DOCTORS } from "../lib/hospitalData";

export default function Doctors() {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 80);
    }
  }, [hash]);

  return (
    <main data-testid="page-doctors">
      <section className="bg-brand-cream relative overflow-hidden">
        <div className="absolute inset-0 grain opacity-40" />
        <div className="container-x py-14 md:py-28 relative">
          <div className="text-xs tracking-[0.25em] uppercase text-brand-crimson font-semibold">Directors & Doctors</div>
          <h1 className="font-display text-[34px] sm:text-5xl lg:text-6xl font-bold text-brand-navy-deep mt-4 max-w-4xl leading-[1.05]">
            Hands you can <span className="italic text-brand-crimson">trust</span> with your heart.
          </h1>
          <p className="mt-5 md:mt-6 text-base md:text-lg text-slate-700 max-w-3xl leading-relaxed">
            Led by experienced super-specialists with national-level training and a deep commitment to ethical, patient-first care.
          </p>
        </div>
      </section>

      <section className="py-14 md:py-20">
        <div className="container-x space-y-12 md:space-y-16">
          {DOCTORS.map((d, i) => (
            <article id={d.id} key={d.id} data-testid={`doctor-${d.id}`} className={`grid lg:grid-cols-12 gap-6 md:gap-10 items-start reveal reveal-${i+1} scroll-mt-32`}>
              <div className={`lg:col-span-4 ${i%2===1 ? "lg:order-2" : ""}`}>
                <div className="relative rounded-3xl overflow-hidden bg-brand-cream aspect-[4/5] sm:aspect-[4/5] max-w-[360px] mx-auto lg:max-w-none border border-border shadow-[0_24px_60px_-30px_rgba(19,60,121,0.4)]">
                  <img src={d.image} alt={d.name} className="absolute inset-0 w-full h-full object-cover object-top" />
                </div>
              </div>
              <div className={`lg:col-span-8 ${i%2===1 ? "lg:order-1" : ""}`}>
                <div className="text-[10.5px] tracking-[0.25em] uppercase text-brand-crimson font-bold">{d.title}</div>
                <h2 className="font-display text-2xl md:text-4xl text-brand-navy-deep mt-2 md:mt-3">{d.name}</h2>
                <div className="flex items-center gap-2 mt-2 md:mt-3 text-slate-600">
                  <GraduationCap className="w-4 h-4 text-brand-navy" />
                  <span className="text-sm font-semibold">{d.qualifications}</span>
                </div>
                <p className="text-slate-700 mt-4 md:mt-6 leading-relaxed text-[14.5px] md:text-[15px]">{d.bio}</p>
                <div className="mt-5 md:mt-6">
                  <div className="text-xs uppercase tracking-widest text-slate-500 font-semibold">Areas of Expertise</div>
                  <div className="flex flex-wrap gap-2 mt-3">
                    {d.specialties.map((sp) => (
                      <span key={sp} className="px-3 py-1.5 rounded-full bg-white border border-border text-xs font-semibold text-brand-navy-deep">
                        {sp}
                      </span>
                    ))}
                  </div>
                </div>
                <Link to="/contact" className="btn-primary mt-6 md:mt-8">Request Appointment <ArrowRight className="w-4 h-4" /></Link>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="py-16 md:py-24 bg-brand-cream">
        <div className="container-x text-center max-w-2xl mx-auto">
          <Award className="w-10 h-10 text-brand-crimson mx-auto" />
          <h2 className="font-display text-2xl md:text-4xl font-bold text-brand-navy-deep mt-4">A growing team of specialists</h2>
          <p className="text-slate-600 mt-3 md:mt-4 text-sm md:text-base">Visiting consultants and full-time super-specialists across cardiology, ENT, oncology, general medicine and surgery — joining us as we scale.</p>
        </div>
      </section>
    </main>
  );
}
